<template>
	<v-card max-width="375" class="mx-auto">
		<v-img :src="getSrc()" height="250" dark>
	  		<v-row class="fill-height">

				<v-card-title class="white--text pl-12 pt-12">
					<div class="text-h4 pl-12 pt-12">
						{{ content.business_name }}
					</div>
				</v-card-title>
	  		</v-row>
		</v-img>

		<v-card-title>

			<v-spacer></v-spacer>

			<v-btn icon  @click="goToShow()">
				<span class="v-icon material-icons black--text">remove_red_eye</span>
			</v-btn>
			<v-btn icon @click="openGoogleMaps()">
				<span class="v-icon material-icons black--text">place</span>
			</v-btn>
			<v-btn icon @click="close()">
				<span class="v-icon material-icons black--text">close</span>
			</v-btn>
		</v-card-title>

		<v-list two-line>
			<v-list-item>
				<v-list-item-icon>
					<span class="material-icons theme--light mr-4">place</span>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{ content.full_address }}</v-list-item-title>
					<v-list-item-subtitle>Indirizzo</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="content.primary_telephone">
				<v-list-item-icon>
					<span class="material-icons mr-4">call</span>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{ content.primary_telephone }}</v-list-item-title>
					<v-list-item-subtitle>Telefono Primario</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider inset></v-divider>

			<v-list-item v-if="content.primary_email">
				<v-list-item-icon>
					<span class="material-icons mr-4">mail</span>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{ content.primary_email }}</v-list-item-title>
					<v-list-item-subtitle>Email Primaria</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider inset></v-divider>

			<v-list-item>
				<v-list-item-icon>
				<span class="material-icons mr-4">person</span>
				</v-list-item-icon>

				<v-list-item-content>
				<v-list-item-title>Responsabile</v-list-item-title>
				<v-list-item-subtitle>{{ content.owner }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-list>
  	</v-card>    
</template>

<script>
	export default {
	  name: 'map-info',
	  props: [ 
		  'content',
		  'apiKey',
		  'router'
	  ],

	methods: {

		close() {
			this.$eventBusUtility.$emit('closeInfoWindow')
		},

		openGoogleMaps() {
		  window.open(this.content.url, '_blank');            
		},

		getSrc() {
		  return 'https://maps.googleapis.com/maps/api/streetview?size=600x300&location=' + this.content.legal_address_lat + ', ' + this.content.legal_address_lng +  '&heading=151.78&pitch=-0.76&key=' + this.apiKey
		},

		goToShow() {
            this.router.push({ name: 'companies-show', params: { id: parseInt(this.content.id)}})
		}
	},
  }
</script>
